'use strict';
'use es6';

/**
 * Instead of implementing this utility directly, use either the ./pick or ./omit utilities which implement this one.
 * Those utilities are designed to mimic the functionality of _.pick and _.omit.
 * @param {Object} object - object to run filters on
 * @param {Boolean} include - true if the filters should include properties of the object on the returned value.
 *                            false if it should exclude them from the returned value.
 * @param {String|String[]} filters - property name or names to include/exclude
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var objectFilter = function objectFilter(object, include) {
  for (var _len = arguments.length, filters = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    filters[_key - 2] = arguments[_key];
  }

  if (object == null) return object;

  var filtersAsArray = filters.reduce(function (filterAccum, filter) {
    if (typeof filter === 'string') {
      return [].concat(_toConsumableArray(filterAccum), [filter]);
    }
    return [].concat(_toConsumableArray(filterAccum), _toConsumableArray(filter));
  }, []);

  return Object.keys(object).reduce(function (prev, key) {
    var passesFilter = include ? _extends({}, prev, _defineProperty({}, key, object[key])) : prev;
    var failsFilter = include ? prev : _extends({}, prev, _defineProperty({}, key, object[key]));
    return filtersAsArray.includes(key) ? passesFilter : failsFilter;
  }, {});
};

exports.default = objectFilter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/utils/underscore/objectFilter.js
// module id = 173
// module chunks = 171